export default __webpack_public_path__ + "static/media/35t.d7bd0af7.jpg";